import * as i0 from '@angular/core';
import { Injectable, inject, isDevMode, NgModule } from '@angular/core';
import * as i2 from '@spartacus/core';
import { Config, LoggerService, provideDefaultConfig } from '@spartacus/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultSegmentRefsConfig = {
  segmentRefs: {
    httpHeaderName: 'Segmentrefs'
  }
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let SegmentRefsConfig = /*#__PURE__*/(() => {
  class SegmentRefsConfig {
    static {
      this.ɵfac = function SegmentRefsConfig_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SegmentRefsConfig)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: SegmentRefsConfig,
        factory: function SegmentRefsConfig_Factory(__ngFactoryType__) {
          let __ngConditionalFactory__ = null;
          if (__ngFactoryType__) {
            __ngConditionalFactory__ = new (__ngFactoryType__ || SegmentRefsConfig)();
          } else {
            __ngConditionalFactory__ = i0.ɵɵinject(Config);
          }
          return __ngConditionalFactory__;
        },
        providedIn: 'root'
      });
    }
  }
  return SegmentRefsConfig;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let OccSegmentRefsInterceptor = /*#__PURE__*/(() => {
  class OccSegmentRefsInterceptor {
    constructor(config, occEndpoints, winRef) {
      this.config = config;
      this.occEndpoints = occEndpoints;
      this.winRef = winRef;
      this.SEGMENT_REFS_KEY = 'segment-refs';
      this.SEGMENT_REFS_QUERY_PARAM = 'segmentrefs';
      this.logger = inject(LoggerService);
      this.initialize();
    }
    /**
     * Fetched the segment reference ID from URL query parameter and saves it into
     * browser local storage
     */
    initialize() {
      const url = this.winRef.location.href ?? '';
      const queryParams = new URLSearchParams(url.substring(url.indexOf('?')));
      this.segmentRefs = queryParams.get(this.SEGMENT_REFS_QUERY_PARAM);
      if (this.segmentRefs) {
        this.winRef.localStorage?.setItem(this.SEGMENT_REFS_KEY, this.segmentRefs);
      } else {
        this.segmentRefs = this.winRef.localStorage?.getItem(this.SEGMENT_REFS_KEY);
      }
      if (this.winRef.isBrowser()) {
        if (!this.config.segmentRefs?.httpHeaderName && isDevMode()) {
          this.logger.warn(`There is no httpHeaderName configured in Segment`);
        }
        this.requestHeader = this.config.segmentRefs?.httpHeaderName?.toLowerCase?.();
      }
    }
    /**
     * Adds a new request header 'Segmentrefs' to the given HTTP request.
     * @param request The outgoing request object to handle.
     * @param next The next interceptor in the chain, or the backend
     * if no interceptors remain in the chain.
     * @returns An observable of the event stream.
     */
    intercept(request, next) {
      if (this.winRef.isBrowser() && this.requestHeader && this.segmentRefs && request.url.includes(this.occEndpoints.getBaseUrl())) {
        request = request.clone({
          setHeaders: {
            [this.requestHeader]: this.segmentRefs
          }
        });
      }
      return next.handle(request);
    }
    static {
      this.ɵfac = function OccSegmentRefsInterceptor_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || OccSegmentRefsInterceptor)(i0.ɵɵinject(SegmentRefsConfig), i0.ɵɵinject(i2.OccEndpointsService), i0.ɵɵinject(i2.WindowRef));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: OccSegmentRefsInterceptor,
        factory: OccSegmentRefsInterceptor.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return OccSegmentRefsInterceptor;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const segmentRefsInterceptors = [{
  provide: HTTP_INTERCEPTORS,
  useExisting: OccSegmentRefsInterceptor,
  multi: true
}];

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let SegmentRefsRootModule = /*#__PURE__*/(() => {
  class SegmentRefsRootModule {
    static {
      this.ɵfac = function SegmentRefsRootModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SegmentRefsRootModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: SegmentRefsRootModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [...segmentRefsInterceptors, provideDefaultConfig(defaultSegmentRefsConfig)]
      });
    }
  }
  return SegmentRefsRootModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * Generated bundle index. Do not edit.
 */

export { SegmentRefsRootModule };
